import { ReactNode } from 'react';

// ddd: div dt dd
export interface DddProps {
  dt: ReactNode;
  dd: ReactNode;
}
export const Ddd = ({ dt, dd }: DddProps) => {
  return (
    <div>
      <dt>{dt}</dt>
      <dd>{dd}</dd>
    </div>
  );
};
